<template>
  <div class="genLocalLicense">

    <el-card class="box-card">
      <h2>License Form</h2>
      <el-form ref="newLicenseForm" label-position="left" :model="newLicenseForm" :rules="genRules" label-width="150px">
        <el-form-item label="Project Name" prop="project">
          <el-input v-model="newLicenseForm.project"></el-input>
        </el-form-item>
        <el-form-item label="Direct Customer" prop="direct_cus" style="text-align:left">
          <el-select v-model="newLicenseForm.direct_cus" filterable placeholder="Please Select"
                     :filter-method="handleCustomerAutoComplete" @change="handleCustomerInputChange" @focus="getCustomerDataList">
            <el-option
              v-for="item in customerData.cus_list"
              :key="item.cus_id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="End Customer" prop="end_cus">
          <el-input v-model="newLicenseForm.end_cus"></el-input>
        </el-form-item>
        <el-form-item label="Expiry Date [as UTC(+00:00)]" prop="exp_date">
          <el-col :span="8">
            <el-date-picker type="date" placeholder="Select Date" :default-value="new Date()" v-model="tmp_exp_date"
                            value-format="yyyy-MM-ddTHH:mm:ss.000Z"
                            @change="OnExpiryDateChange"
                            :disabled="datePickerDisable" style="width: 100%;"></el-date-picker>
          </el-col>
          <el-checkbox v-model="checked" @change="OnCheckBoxChange">No Limit</el-checkbox>
        </el-form-item>
        <el-form-item label="Customer Email" prop="user_email">
          <el-input type="email" v-model="newLicenseForm.user_email" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="ER Number" prop="er_num" style="text-align:left">
          <el-select v-model="newLicenseForm.er_num" disabled multiple filterable allow-create default-first-option placeholder="Enter ER Number">
            <el-option disabled
                       v-for="item in er_options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="NE Point" prop="ne_point">
          <el-input type="number" v-model="newLicenseForm.ne_point" clearable></el-input>
        </el-form-item>
        <el-form-item label="Enable White Label" prop="white_label" style="text-align:left">
          <el-checkbox v-model="newLicenseForm.white_label"></el-checkbox>
        </el-form-item>
        <el-form-item label="PI Number" prop="pi_num">
          <el-input v-model="newLicenseForm.pi_num"></el-input>
        </el-form-item>
        <el-form-item label="Support Duration" prop="support_dr" style="text-align:left">
          <el-input type="number" v-model="newLicenseForm.support_dr" min="0" style="width: 20%;"
                    @change="OnSupportDrChange"
                    @blur="OnSupportDrChange">
          </el-input>
          (years)
          <br><small style="text-align:left; color:slateblue;">
          {{ newLicenseForm.support_dr_date == null ? "" : newLicenseForm.support_dr_date.format("DD MMM YYYY") }}
        </small>
        </el-form-item>
        <el-form-item label="Sales Name" prop="sales">
          <el-input v-model="newLicenseForm.sales"></el-input>
        </el-form-item>
        <el-form-item label="Sales Email" prop="sales_email">
          <el-input v-model="newLicenseForm.sales_email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" plain @click="genLocalLicense" :loading="loading">Submit</el-button>
          <el-button type="info" plain @click="$router.push('generate')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {generateLicense, getCustomerList, searchCustomerAutoComplete} from '../api'
import moment from 'moment'
export default {
  name: 'GenLocalLicense',
  data () {
    console.log(this.$route.params.data)
    return {
      loading: false,
      checked: false,
      datePickerDisable: false,
      jsonData: String,
      hwInfoData: this.$route.params.data,
      customerData: {},
      er_options: [],
      newLicenseForm: {
        project: null,
        direct_cus: null,
        end_cus: null,
        exp_date: null,
        user_email: null,
        er_num: null,
        pi_num: null,
        support_dr: null,
        support_dr_date: null,
        lic_type: 0,
        ne_point: 0,
        white_label: false,
        sales: null,
        sales_email: null
      },
      genRules: {
        project: [
          { required: true, message: 'Please Enter Project Name', trigger: 'blur' }
        ],
        direct_cus: [
          { required: true, message: 'Please Enter Direct Customer Name', trigger: 'blur' }
        ],
        exp_date: [
          { type: 'date', required: true, message: 'Please Select a Expire Date', trigger: 'blur' }
        ],
        user_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid User Email', trigger: 'blur' }
        ],
        er_num: [
          { required: true, message: 'Please Enter ER Number', trigger: 'blur' }
        ],
        ne_point: [
          { required: true, message: 'Please Enter NE Point', trigger: 'blur' }
        ],
        sales_email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ]
      }
    }
  },
  created: function () {
    console.log('GenLocalLicense - created')
    this.newLicenseForm.er_num = this.$route.params.er_num.split(',')

    console.log('er_num')
    console.log(this.newLicenseForm.er_num)
  },
  methods: {
    getCustomerDataList (val) {
      let that = this
      console.log('getCustomerList val')
      console.log(val)

      getCustomerList().then(data => {
        console.log('getCustomerList Succeed')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
        that.searching = false
      })
    },
    handleCustomerAutoComplete (value) {
      const that = this
      console.log('handleCustomerAutoComplete --> value')
      console.log(value)
      searchCustomerAutoComplete(value).then(data => {
        console.log('searchCustomerAutoComplete Success -> data')
        console.log(data)
        that.customerData = data
      }).catch(error => {
        if (error) {
          console.log(error.stack)
        }
      })
    },
    handleCustomerInputChange (val) {
      console.log('handleCustomerInputChange -> val')
      console.log(val)

      this.newLicenseForm.direct_cus = val.name
      this.newLicenseForm.cus_id = val.cus_id
      this.newLicenseForm.user_email = val.email
    },
    OnCheckBoxChange (value) {
      let that = this

      console.log('OnCheckBoxChange - value = ')
      console.log(value)

      if (value === true) {
        that.newLicenseForm.exp_date = -1
        that.datePickerDisable = true
      } else {
        that.newLicenseForm.exp_date = null
        that.datePickerDisable = false
      }
    },
    OnSupportDrChange (value) {
      var tmpDate = moment.utc()

      console.log('OnSupportDrChange - support_dr = ')
      console.log(this.newLicenseForm.support_dr)

      tmpDate.add(this.newLicenseForm.support_dr, 'years')
      this.newLicenseForm.support_dr_date = tmpDate
    },
    OnExpiryDateChange (value) {
      var datum = Date.parse(value)
      this.newLicenseForm.exp_date = datum
    },
    genLocalLicense () {
      const that = this
      that.$refs.newLicenseForm.validate((valid) => {
        if (valid) {
          that.loading = true
          console.log('newLicenseForm')
          console.log(that.newLicenseForm)
          console.log('hwInfoData')
          console.log(that.hwInfoData)

          // Convert to Numeric Value
          that.newLicenseForm.support_dr = parseInt(that.newLicenseForm.support_dr)

          that.jsonData = {'all_feature': parseInt(that.newLicenseForm.ne_point), 'white_label': that.newLicenseForm.white_label}
          // lic_type == 0 (WEB), and lic_type == 1 (LOCAL)
          Object.assign(that.newLicenseForm, {'lic_type': 1})
          Object.assign(that.newLicenseForm, {'license_content': that.jsonData})
          Object.assign(that.newLicenseForm, {'hwInfo': that.hwInfoData})

          generateLicense(that.newLicenseForm).then(data => {
            that.loading = false
            console.log('generateLicense Success -> data.data')
            console.log(data.data)
            that.$router.push({name: 'CompleteLicense', params: {data: data.data}})
          }).catch(error => {
            if (error) {
              console.log(error.stack)
            }
            that.loading = false
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// GenLocalLicense.vue?d69a592c